import { jsx as _jsx } from "react/jsx-runtime";
export var TabItem = function TabItem(_ref) {
  var children = _ref.children,
    className = _ref.className;
  return _jsx("div", {
    className: className,
    children: children
  });
};